import React from "react";
import { PublicLanguageProvider, usePublicLanguage } from "../../context/PublicLanguage";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";

function PublicContent() {
  const { language } = usePublicLanguage();
  return (
    <div lang={language} className="min-h-screen flex flex-col" style={{ background: "#08090A" }}>
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function PublicLayout() {
  return <PublicLanguageProvider><PublicContent /></PublicLanguageProvider>;
}
